module.exports = __webpack_public_path__ + "static/media/icon-person-location.0a179e16.svg";